export default function PHP_getCode() {
  return (
    <div>
      <h1>PHP_getCode</h1>
    </div>
  );
}
